export default "__VITE_ASSET__Dw0YT4xf__"